module.exports = __webpack_public_path__ + "static/media/IMG_5705.b65428a6.jpg";